<template>
  <PurpleHeader />
  <router-view/>
  <ModalContainer v-if="this.$error" :data="this.$error" @closedEvent="errorModalClosed" isError="true"/>
  <ModalContainer v-if="this.$info" :data="this.$info" @closedEvent="infoModalClosed" isError="false"/>
</template>

<script>
  import ModalContainer from '@/components/ModalContainer.vue'
  import PurpleHeader from '@/components/PurpleHeader.vue'

  export default {
    components: {
      PurpleHeader,
      ModalContainer
    },
    methods: {
      errorModalClosed() {
        if (this.$error && this.$error.callback) {
          this.$error.callback();
        }

        this.$error=null;
      },
      infoModalClosed() {
        if (this.$info && this.$info.callback) {
          this.$info.callback();
        }

        this.$info=null;
      }
    }
  }
</script>
